// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Properties/Content/Content/Content/ActiveStep/Http/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Properties_Content_Content_Content_ActiveStep_Http($app_id: uuid!, $key: String!) {
  apps_properties_property_source_values(app_id: $app_id, key: $key) {
    id
    text: value
  }
}

`